App.directive('navTpl', ['$window', function ($window) {
    return {
        restrict: 'AEC',
        scope: {
        	color: '@'
        },
        templateUrl: 'Templates/nav-tpl.html',
        link: function(scope) {
        	// var isLogged = window.sessionStorage.getItem('isLogged');
        	// var reg = isLogged === undefined || isLogged === null || isLogged.length == 0;

        	// if (!reg) {
        	// 	scope.logged = true;
        	// }
        }
    };
}]);